import { AcrossRefund } from '@optimex-xyz/trade-wallet-sdk'

import { IResponse, Model, ObjectsFactory } from '@/data/core'
import { ACROSS_TRADE_ENDPOINT, TRADES_ENDPOINT } from '@/data/endpoint'

import { BytesLike } from 'ethers'

export interface IAcrossTradeAuthRequest {
  infoHash: string
}

export interface IAcrossTradeAuthResponse {
  signature: string
}

export interface AcrossRequestRefundParams {
  tradeId: BytesLike
  expireTime: bigint
  details: AcrossRefund.RequestStruct
  authSig: BytesLike
}
export interface AcrossRequestRefundResponse {
  txHash: string
}

export class AcrossTradeAuth extends Model {
  static config = { endpoint: TRADES_ENDPOINT }

  static objects = ObjectsFactory.factory<void>(AcrossTradeAuth.config)

  static async getAcrossOptimexAuthSig(requestBody: IAcrossTradeAuthRequest) {
    return await this.service.post<IResponse<IAcrossTradeAuthResponse>>({
      url: ACROSS_TRADE_ENDPOINT.OPTIMEX_AUTH,
      payload: requestBody,
    })
  }
  static async requestRefund(requestBody: AcrossRequestRefundParams) {
    return await this.service.post<IResponse<AcrossRequestRefundResponse>>({
      url: ACROSS_TRADE_ENDPOINT.ACROSS_REQUEST_REFUND,
      payload: requestBody,
    })
  }
}

AcrossTradeAuth.init(AcrossTradeAuth.config)
